import { Dropdown, Collapse } from 'bootstrap'; // eslint-disable-line
import OPL from './app/OPL';

window.OPL = new OPL();
